type DividerProps = {
  className?: string;
  width?: string | number;
  mt?: "5" | "6";
};

export default function Divider({
  className = "",
  width,
  mt = "5",
}: DividerProps) {
  const marginTop = mt === "5" ? "mt-5" : "mt-6";
  const widthClass = width ? "" : "w-full max-w-3xl";

  return (
    <div
      className={`mx-auto ${marginTop} h-px bg-[#E3F1CE] ${widthClass} ${className}`}
      style={width ? { width: typeof width === "number" ? `${width / 16}rem` : width, maxWidth: "100%" } : undefined}
    />
  );
}

